// @flow

import { TRANSLATIONS_LOADING } from './translations.actionTypes'

export function loadTranslations() {
  return {
    type: TRANSLATIONS_LOADING,
  }
}
